<template>
  <div class="author-detail">
    <div class="author-detail-content">
      <div>
        <div class="left-author-content">
          <div class="title theme-title">作者信息</div>
          <div class="author-avatar flex-center">
            <img
              :src="
                authorInfo.authorPortrait
                  ? authorInfo.authorPortrait
                  : defaultImg
              "
              alt=""
            />
          </div>
          <el-tooltip
            :content="authorInfo.authorName"
            placement="top"
            v-ak-tooltip-auto-show
          >
            <div class="author-name ellipsis-aRow">
              {{ authorInfo.authorName }}
            </div>
          </el-tooltip>

          <div class="author-info ellipsis-aRow">
            国籍：{{
              authorInfo.nationality == null || authorInfo.nationality == ""
                ? "-"
                : authorInfo.nationality
            }}
          </div>
          <div class="author-info ellipsis-aRow">
            民族：{{
              authorInfo.nation == null || authorInfo.nation == "-"
                ? "-"
                : authorInfo.nation
            }}
          </div>
          <div class="author-info ellipsis-aRow">
            商品数量：{{
              authorInfo.resourceCount ? authorInfo.resourceCount : 0
            }}本
          </div>
          <div class="author-info ellipsis-aRow">
            <el-tooltip
              :content="authorInfo.academicField"
              placement="top"
              v-ak-tooltip-auto-show
            >
              <span class="academicF ellipsis-aRow"
                >学术领域：{{ authorInfo.academicField }}</span
              >
            </el-tooltip>
          </div>
          <div class="author-info ellipsis-aRow">
            机构：
            <el-tooltip
              :content="authorInfo.cpName"
              placement="top"
              v-ak-tooltip-auto-show
            >
              <span
                class="cpName ellipsis-aRow"
                @click="toCoagency(authorInfo.deptId)"
                style="color: #2e9adb"
                >{{ authorInfo.cpName }}</span
              >
            </el-tooltip>
          </div>
          <el-divider
            v-if="
              authorInfo.introduction != null || authorInfo.introduction != ''
            "
          ></el-divider>
          <div
            v-if="
              authorInfo.introduction != null || authorInfo.introduction != ''
            "
            class="author-introduction"
          >
            <span class="allIntro">{{ authorInfo.introduction }}</span>
          </div>
        </div>
      </div>
      <div class="right-content">
        <div class="right-header">
          <div class="title theme-title">商品列表</div>
          <div class="custom-search search">
            <input
              type="text"
              v-model.trim="queryParams.goodsName"
              @keyup.enter="handleQuery"
              class="custom-input"
              placeholder="请输入"
            />
            <el-button
              type="primary"
              icon="el-icon-search"
              class="custom-button"
              @click="handleQuery"
              >搜索</el-button
            >
          </div>
        </div>
        <booklist-box
          :goodsTypeList="goodsTypeList"
          :data-list="bookList"
        ></booklist-box>
        <noData v-if="total == 0"></noData>
        <!-- <el-pagination
          v-show="total > 0"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParams.pageNum"
          :page-sizes="[10, 20, 30, 40, 50]"
          :page-size="queryParams.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination> -->
        <div class="pagination-box" v-show="total > 0">
          <el-pagination
            class="ou-pagination"
            background
            hide-on-single-page
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryParams.pageNum"
            :page-sizes="[10, 20, 30, 40, 50]"
            :page-size="queryParams.pageSize"
            layout="total, prev, pager, next, sizes, jumper, slot"
            :total="total"
          >
            <el-button @click="getList()" class="ou-page-go">GO</el-button>
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import noData from "@/components/noData.vue";
import { AuthorInfo, ListResource } from "@/api/authorLibrary/authorLibrary";
import { teachingAttrList } from "@/api/bookstore/bookstore";
import booklistBox from "@/components/booklistBox.vue";
export default {
  data() {
    return {
      showMore: false,
      defaultImg: require("@/assets/images/default-avatar.jpg"),
      authorInfo: {},
      authorId: null,
      total: 0,
      bookList: [],
      //查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        authorId: null,
        goodsName: "",
      },
      goodsTypeList: [],
    };
  },
  components: { booklistBox, noData },
  created() {
    this.authorId = this.$route.query.authorId;
    this.getList();
    teachingAttrList("oc_resource_file").then((res) => {
      console.log(res.data);
      this.goodsTypeList = res.data;
    });
  },
  watch: {
    //监听路由变化
    $route() {
      if (this.$route.query.authorId) {
        this.authorId = this.$route.query.authorId;
        this.getList();
      }
    },
  },
  methods: {
    enterShow() {
      if (this.authorInfo.introduction.length > 200) {
        this.showMore = true;
      }
    },
    leaveShow() {
      this.showMore = false;
    },
    getList() {
      //左侧作者信息
      AuthorInfo(this.authorId).then((res) => {
        this.authorInfo = res.data;
      });
      //右侧商品列表
      this.queryParams.authorId = this.authorId;
      ListResource(this.queryParams).then((res) => {
        if (res.code == 200) {
          // console.log(res)
          this.bookList = res.rows;
          this.total = res.total;
        }
      });
    },
    // 搜索按钮操作
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    //跳转机构详情
    toCoagency(id) {
      if (this.authorInfo.cpIsEnable === "1") {
        this.$message.error("该机构已停用");
      } else {
        this.$router.push({
          path: "/coagency/coagencyDetail",
          query: { deptId: id },
        });
      }
    },
    //每页条数
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.getList();
    },
    //当前页面
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getList();
    },
  },
};
</script>
<style scoped lang='scss'>
.author-detail {
  height: auto;
  padding-bottom: 40px;
  // background: #f2f2f2;
  .author-detail-content {
    width: 1400px;
    min-height: 668px;
    margin: 0 auto;
    display: flex;
    .left-author-content {
      width: 304px;
      // min-height: 668px;
      background: #fffefd;
      margin-right: 16px;
      box-sizing: border-box;
      padding: 15px 8px 20px;
      .title {
        margin: 0 0 16px 7px;
      }
      .author-avatar {
        width: 130px;
        height: 130px;
        margin: 0 auto 20px;
        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }
      .author-name {
        margin-bottom: 7px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #333333;
        text-align: center;
      }
      .author-info {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #333333;
        margin-top: 13px;
        box-sizing: border-box;
        padding: 0 10px 0 22px;
        display: flex;
        a {
          text-decoration: none;
        }
        .cpName {
          cursor: pointer;
        }
      }
      .el-divider--horizontal {
        margin: 20px 0;
      }
      .author-introduction {
        width: 288px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 21px;
        box-sizing: border-box;
        padding: 0 25px 0 22px;
        // position: relative;
        // word-break: break-all;
        .partIntro {
          display: -webkit-box;
          -webkit-line-clamp: 13; /*行数*/
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .allIntro {
          box-sizing: border-box;
          padding: 0 25px 10px 22px;
          text-indent: 2rem;
        }
      }
    }
    .right-content {
      width: 1080px;
      min-height: 668px;
      background: #fffefd;
      padding: 16px 25px 30px 20px;
      box-sizing: border-box;
      .right-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 0 5px 0 20px;
        border-bottom: 1px solid #f2f2f2;
        margin-bottom: 30px;
        .title {
          margin-top: -15px;
        }
        .search {
          border: none;
          width: 280px;
        }
      }
      .pagination-box {
        text-align: right;
        margin-top: 28px;
      }
    }
  }
}
</style>
